import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { setupPhaseFooterRoutes } from '../utils/nav';
import { GuardsUtils } from './guards-utils';
import { RunPhaseType } from 'chronos-core-client';

export const setupSubPhaseNavigationGuard = (next: ActivatedRouteSnapshot) => {
  const guardsUtils: GuardsUtils = inject(GuardsUtils);
  return guardsUtils.navigateToSubPhase(next, RunPhaseType.Setup, setupPhaseFooterRoutes);
};
